import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
// zencera design system, in cascade order: self-hosted fonts, generated
// tokens, the system's component classes, then the app layer.
import './design/fonts.css';
import './design/tokens.css';
import './design/components.css';
import './styles.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
